import classnames from 'classnames';
import { Container } from '@stadionhq-v3/base-ui';
import {
  ArrowLeft,
  ArrowRight,
  ArrowUp,
} from '@stadionhq-v3/scottishfa-web-tokens/dist/components/icons';
import { SfaPlayerProfileNavProps } from './sfaPlayerProfileNav.types';
import styles from './sfaPlayerProfileNav.module.scss';

const splitName = (label: string) => {
  const trimmed = label.trim();
  const lastSpace = trimmed.lastIndexOf(' ');
  if (lastSpace === -1) return { firstNames: '', lastName: trimmed };
  return {
    firstNames: `${trimmed.slice(0, lastSpace)} `,
    lastName: trimmed.slice(lastSpace + 1),
  };
};

const PlayerLabel = ({ label }: { label: string }) => {
  const { firstNames, lastName } = splitName(label);
  return (
    <span className={styles.label}>
      {firstNames ? (
        <span className={styles.labelFirst}>{firstNames}</span>
      ) : null}
      <span className={styles.labelLast}>{lastName}</span>
    </span>
  );
};

const SfaPlayerProfileNav = ({
  nativeProps = {},
  classNames = [],
  testId = 'sfa-player-profile-nav',
  previous,
  next,
  full,
}: SfaPlayerProfileNavProps) => (
  <nav
    {...nativeProps}
    data-testid={testId}
    aria-label="Player navigation"
    className={classnames(styles.sfaPlayerProfileNav, classNames)}
  >
    <Container classNames={[classnames(styles.inner)]}>
      {previous ? (
        <a
          className={classnames(styles.link, styles['link--prev'])}
          href={previous.url}
        >
          <span className={styles.arrow} aria-hidden="true">
            <ArrowLeft />
          </span>
          {previous.avatar ? (
            <span className={styles.avatar} aria-hidden="true">
              {previous.avatar}
            </span>
          ) : null}
          <PlayerLabel label={previous.label} />
        </a>
      ) : (
        <span className={styles.spacer} />
      )}

      {full ? (
        <a
          className={classnames(styles.link, styles['link--full'])}
          href={full.url}
        >
          <span className={styles.arrow} aria-hidden="true">
            <ArrowUp />
          </span>
          <span className={styles.label}>{full.label}</span>
        </a>
      ) : (
        <span className={styles.spacer} />
      )}

      {next ? (
        <a
          className={classnames(styles.link, styles['link--next'])}
          href={next.url}
        >
          <PlayerLabel label={next.label} />
          {next.avatar ? (
            <span className={styles.avatar} aria-hidden="true">
              {next.avatar}
            </span>
          ) : null}
          <span className={styles.arrow} aria-hidden="true">
            <ArrowRight />
          </span>
        </a>
      ) : (
        <span className={styles.spacer} />
      )}
    </Container>
  </nav>
);

export default SfaPlayerProfileNav;
